export interface BienBanBanGiao {
    id?: number;
    //maBienBan: string;
    ngayLap: Date;
    idDonViGiao: number;
    tenDonViGiao?: string;
    idDonViNhan: number;
    tenDonViNhan?: string;
    noiDungBanGiao?: string;
    diaDiem?: string;
    trangThai: number;
    lyDoTuChoi?: string;
    tinhTrang?: number;
    soLuongTaiSan?: number;
    idNVKhoiTao?: number;
    coTheXacNhan?: boolean;
    danhSachNguoiDaiDienGiao?: NguoiDaiDienResponse[];
    danhSachNguoiDaiDienNhan?: NguoiDaiDienResponse[];
    danhSachXacNhan?: XacNhanBanGiaoResponse[];
}

export interface NguoiDaiDienResponse {
    idNhanVien: number;
    tenNhanVien: string;
    chucVu?: string;
}

export interface XacNhanBanGiaoResponse {
    id: number;
    idNhanVien: number;
    tenNhanVien: string;
    loaiXacNhan: number;
    trangThaiXacNhan: number;
    ngayXacNhan?: Date;
    lyDo?: string;
}

export interface ChiTietBienBanBanGiaoModel extends BienBanBanGiao {
    danhSachTaiSan?: ChiTietBanGiao[];
}

export interface ChiTietBanGiao {
    id?: number;
    idTaiSan: number;
    maTaiSan?: string;
    tenTaiSan?: string;
    loaiTaiSan?: string;
    soLuong: number;
    tinhTrangTaiSan?: string;
    idNVSuDungSauBanGiao?: number;
    tenNVSuDungSauBanGiao?: string;
    idDonViSuDung?: number;
    tenDonViSuDung?: string;
    isDonViChinh?: boolean;
    ghiChu?: string;
}

export interface BienBanBanGiaoRequest {
    id?: number;
    //maBienBan: string;
    ngayLap: string;
    idDonViGiao: number;
    idDonViNhan: number;
    noiDungBanGiao?: string;
    diaDiem?: string;
    trangThai: number;
    danhSachNguoiDaiDienGiao: number[];
    danhSachNguoiDaiDienNhan: number[];
    danhSachTaiSan: ChiTietBanGiaoRequest[];
}

export interface ChiTietBanGiaoRequest {
    id?: number;
    idTaiSan: number;
    soLuong: number;
    tinhTrangTaiSan?: string;
    idNVSuDungSauBanGiao?: number;
    idDonViSuDung: number;
    isDonViChinh: boolean;
    ghiChu?: string;
}

export interface TimKiemBienBanBanGiaoRequest {
    tuKhoa?: string;
    trangThai?: number;
    idDonViGiao?: number;
    idDonViNhan?: number;
    tuNgay?: Date;
    denNgay?: Date;
}

// Trạng thái biên bản bàn giao
export enum TrangThaiBienBanBanGiao {
    DuThao = 0,
    ChoXacNhan = 1,
    HoanThanh = 2,
    ThuHoi = 3,
    Huy = 4,
}
